<script>
import { debounce } from 'debounce'
import { authComputed } from '@state/helpers'
import appConfig from '@src/app.config'

export default {
  name: 'TopMenu',
  components: {},
  props: {
    notifications: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      searchTerm: '',
    }
  },
  computed: {
    unreadNotificationsCounter() {
      let unread = 0
      for (var i = this.notifications.length - 1; i >= 0; i--) {
        if (this.notifications[i].read_at == null) {
          unread++
        }
      }
      return unread
    },
    kyndhubId() {
      return +appConfig.kyndhub_id
    },
    ...authComputed,
  },
  methods: {
    showUserEdit() {
      this.$emit('show-user-edit')
    },
    showNotificationsDrawer(e) {
      this.$emit('show-notifications-drawer', e)
    },
    search: debounce(async function search() {
      this.$emit('search', {
        searchTerm: this.searchTerm,
      })
    }, 500),
  },
}
</script>

<template>
  <div
    class="fixed top-0 w-full z-navbar bg-blue-lightest h-28 px-10 py-7 flex justify-between"
  >
    <div class="flex flex-grow justify-between max-w-5xl">
      <router-link
        :to="{
          name: 'company',
          params: {
            companyId: currentUser.default_company_id
              ? currentUser.default_company_id
              : kyndhubId,
          },
        }"
      >
        <svg
          id="svg2"
          xmlns:dc="http://purl.org/dc/elements/1.1/"
          xmlns:cc="http://creativecommons.org/ns#"
          xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
          xmlns:svg="http://www.w3.org/2000/svg"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
          xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
          version="1.1"
          xml:space="preserve"
          width="140"
          height="54"
          viewBox="0 0 942.82666 363.35999"
          sodipodi:docname="pencil-2016-logo.eps"
        >
          <metadata id="metadata8">
            <rdf:RDF
              ><cc:Work rdf:about=""
                ><dc:format>image/svg+xml</dc:format
                ><dc:type
                  rdf:resource="http://purl.org/dc/dcmitype/StillImage"/></cc:Work
            ></rdf:RDF>
          </metadata>
          <defs id="defs6" />
          <sodipodi:namedview
            id="namedview4"
            pagecolor="#ffffff"
            bordercolor="#666666"
            borderopacity="1"
            objecttolerance="10"
            gridtolerance="10"
            guidetolerance="10"
            inkscape:pageopacity="0"
            inkscape:pageshadow="2"
            inkscape:window-width="640"
            inkscape:window-height="480"
          />
          <g
            id="g10"
            inkscape:groupmode="layer"
            inkscape:label="ink_ext_XXXXXX"
            transform="matrix(1.3333333,0,0,-1.3333333,0,363.36)"
          >
            <g id="g12" transform="scale(0.1)">
              <path
                id="path14"
                d="M 1045.76,1155.58 H 710.34 L -0.00390625,1449.71 V 345.469 L 715.008,0 H 878.051 1041.09 L 1756.1,345.469 V 1449.71 l -710.34,-294.13"
                style="fill:#7ec8e9;fill-opacity:1;fill-rule:nonzero;stroke:none"
              />
              <path
                id="path16"
                d="m 1391.2,1877.1 c -117.34,0 -217.21,-73.71 -256.57,-177.25 -38.92,102.4 -137.095,175.51 -252.786,177.1 -115.688,-1.59 -213.86,-74.7 -252.789,-177.1 -39.352,103.54 -139.227,177.25 -256.571,177.25 -151.711,0 -274.6988,-122.99 -274.6988,-274.7 0,-9.46 0.4804,-18.81 1.4218,-28.02 0.1446,-1.52 0.4883,-2.95 0.668,-4.46 l 435.508,-188.33 176.461,-76.3 h 170 169.986 l 176.47,76.3 435.52,188.33 c 0.17,1.51 0.51,2.94 0.67,4.46 0.92,9.21 1.41,18.56 1.41,28.02 0,151.71 -122.99,274.7 -274.7,274.7"
                style="fill:#baac95;fill-opacity:1;fill-rule:nonzero;stroke:none"
              />
              <path
                id="path18"
                d="M 881.844,2725.15 333.98,2037.3 h 33.84 c 108.93,0 204.082,-58 257.012,-144.61 52.93,86.61 148.07,144.61 257.012,144.61 108.941,0 204.076,-58 257.006,-144.61 52.93,86.61 148.08,144.61 257.01,144.61 h 33.84 l -547.856,687.85"
                style="fill:#513e1a;fill-opacity:1;fill-rule:nonzero;stroke:none"
              />
              <path
                id="path20"
                d="m 2507.59,1364.34 h 123.3 c 78.1,0 134.44,16.28 168.99,48.86 34.56,32.56 51.84,86.33 51.84,161.31 0,52.44 -7.78,92.68 -23.31,120.75 -15.54,28.06 -38.34,48.86 -68.4,62.38 -30.06,13.51 -79.45,20.28 -148.14,20.28 -45.39,0 -74.13,-4.31 -86.19,-12.91 -12.06,-8.6 -18.09,-23.56 -18.09,-44.86 z m -274.7,454.13 h 448.36 c 101.27,0 178.56,-22.95 231.86,-68.82 53.3,-45.89 79.95,-105.91 79.95,-180.06 0,-74.15 -24.55,-130.69 -73.64,-169.61 -67.52,-53.67 -150.78,-80.5 -249.8,-80.5 h -162.03 v -310.34 c 0,-18.031 4.3,-30.941 12.9,-38.71 11.47,-9.84 26.83,-14.75 46.09,-14.75 h 103.24 v -46.09 h -436.93 v 46.09 h 91.35 c 18.1,0 31.36,3.57 39.8,10.75 8.43,7.16 12.65,16.902 12.65,29.191 v 724.529 c 0,18.44 -5.35,31.74 -16.04,39.94 -10.7,8.2 -30.87,12.29 -60.49,12.29 h -67.27 v 46.09"
                style="fill:#513e1a;fill-opacity:1;fill-rule:nonzero;stroke:none"
              />
              <path
                id="path22"
                d="m 3055.8,1818.47 h 720.23 l 17.21,-306.65 h -41.19 c -16.35,96.69 -42.23,164.29 -77.62,202.8 -35.39,38.5 -81.52,57.76 -138.37,57.76 h -177.97 c -14.33,0 -25.17,-3.89 -32.54,-11.67 -7.36,-7.79 -11.04,-19.66 -11.04,-35.64 v -323.86 h 77.83 c 41.67,0 75.48,14.95 101.42,44.86 25.95,29.9 39.93,75.79 41.98,137.66 h 42.41 v -420.96 h -42.41 c -2.05,69.65 -16.25,119.53 -42.59,149.64 -26.35,30.12 -62.2,45.17 -107.55,45.17 h -71.09 V 996.238 c 0,-13.117 4.4,-23.156 13.2,-30.117 8.79,-6.961 23.42,-10.441 43.88,-10.441 h 140.54 c 152.61,0 240.57,97.49 263.9,292.51 h 44.24 l -15.36,-338.6 H 3055.8 v 46.09 h 62.06 c 24.17,0 41.18,4.191 51.01,12.601 9.83,8.391 14.75,20.578 14.75,36.559 v 720.23 c 0,15.98 -4.3,27.85 -12.9,35.64 -8.61,7.78 -22.13,11.67 -40.57,11.67 h -74.35 v 46.09"
                style="fill:#513e1a;fill-opacity:1;fill-rule:nonzero;stroke:none"
              />
              <path
                id="path24"
                d="m 3933.96,1818.47 h 216.92 l 548.17,-714.08 v 516.82 c 0,52.02 -11.89,90.54 -35.65,115.54 -21.72,22.93 -54.07,34.81 -97.09,35.63 v 46.09 h 318.32 v -46.09 c -32.52,0 -56.8,-4.5 -72.86,-13.52 -16.05,-9.01 -30.04,-25.4 -41.97,-49.16 -11.95,-23.76 -17.9,-49.77 -17.9,-78.04 V 909.59 h -57.77 l -567.21,743.43 v -548.53 c 0,-49.61 12.49,-86.61 37.49,-111.002 24.98,-24.386 63.7,-36.996 116.14,-37.808 v -46.09 h -346.59 v 46.09 c 43.42,1.629 77.83,15.851 103.24,42.652 25.39,26.778 38.1,59.618 38.1,98.478 v 615.51 l -10.81,11.85 c -20.46,22.31 -35,35.51 -43.56,39.61 -11.85,5.73 -27.15,8.6 -45.94,8.6 h -41.03 v 46.09"
                style="fill:#513e1a;fill-opacity:1;fill-rule:nonzero;stroke:none"
              />
              <path
                id="path26"
                d="m 5585.85,1747.8 42.4,87.88 h 38.73 l 15.97,-365.64 h -41.17 c -27.04,102.82 -61.05,178.61 -102.01,227.37 -50.81,61.04 -111.45,91.57 -181.91,91.57 -76.2,0 -138.27,-34.01 -186.2,-102.02 -47.93,-68 -71.89,-183.13 -71.89,-345.36 0,-136.43 27.44,-240.49 82.34,-312.18 46.7,-60.631 112.25,-90.951 196.65,-90.951 73.74,0 135.6,23.66 185.59,70.981 49.98,47.31 82.55,118.7 97.7,214.16 h 43.64 c -12.71,-108.15 -49.78,-191.33 -111.23,-249.501 -61.45,-58.179 -138.88,-87.257 -232.29,-87.257 -75.8,0 -145.34,19.046 -208.63,57.148 -63.3,38.102 -113.91,92.89 -151.79,164.39 -37.9,71.48 -56.84,149.84 -56.84,235.05 0,90.54 19.56,175.55 58.68,255.03 39.12,79.48 89.21,139.19 150.25,179.14 61.05,39.94 126.8,59.92 197.27,59.92 39.32,0 77.43,-6.77 114.3,-20.28 36.87,-13.52 77.01,-36.67 120.44,-69.45"
                style="fill:#513e1a;fill-opacity:1;fill-rule:nonzero;stroke:none"
              />
              <path
                id="path28"
                d="m 5788.06,1818.47 h 419.1 v -46.09 h -71.89 c -31.97,0 -52.14,-3.99 -60.54,-11.98 -8.4,-7.99 -12.6,-24.88 -12.6,-50.7 v -688.27 c 0,-27.45 3.69,-44.66 11.07,-51.621 9.83,-9.43 27.65,-14.129 53.46,-14.129 h 80.5 v -46.09 h -419.1 v 46.09 h 79.27 c 27.86,0 45.88,4.082 54.08,12.289 8.19,8.191 12.28,26.011 12.28,53.461 v 688.27 c 0,26.21 -3.68,42.41 -11.05,48.55 -11.48,9.42 -32.57,14.13 -63.3,14.13 h -71.28 v 46.09"
                style="fill:#513e1a;fill-opacity:1;fill-rule:nonzero;stroke:none"
              />
              <path
                id="path30"
                d="m 6293.2,1818.47 h 421.57 v -46.09 h -100.78 c -15.98,0 -27.77,-4.2 -35.34,-12.59 -7.58,-8.41 -11.37,-21.61 -11.37,-39.64 v -717.16 c 0,-17.201 4.8,-29.4 14.42,-36.56 9.61,-7.18 28.95,-10.75 58,-10.75 h 127.65 c 67.92,0 123.45,22.629 166.62,67.9 43.16,45.26 74.56,123.83 94.21,235.67 h 43.01 L 7050.3,909.59 h -757.1 v 46.09 h 74.36 c 25.39,0 43.21,4.808 53.46,14.429 10.23,9.629 15.37,25.102 15.37,46.401 v 709.79 c 0,15.15 -4.31,26.62 -12.91,34.41 -8.6,7.78 -21.31,11.67 -38.1,11.67 h -92.18 v 46.09"
                style="fill:#513e1a;fill-opacity:1;fill-rule:nonzero;stroke:none"
              />
            </g>
          </g>
        </svg>
      </router-link>

      <div class="topbar-item w-56 relative">
        <input
          v-model="searchTerm"
          type="text"
          name="search"
          class="input align-middle pl-10"
          @input="search"
        />
        <svg
          class="absolute left-0 top-0 mt-5 ml-4"
          xmlns="http://www.w3.org/2000/svg"
          width="16.187"
          height="16.142"
          viewBox="0 0 16.187 16.142"
        >
          <g transform="translate(17.622 0.071)">
            <path
              class="a"
              d="M-1.673,14.693l-3.6-3.615a6.9,6.9,0,0,0-1.2-9.689,6.9,6.9,0,0,0-9.688,1.2,6.9,6.9,0,0,0,1.2,9.689,6.9,6.9,0,0,0,8.554-.051l3.6,3.611a.809.809,0,0,0,1.14,0h0A.809.809,0,0,0-1.673,14.693ZM-10.7,12.12a5.3,5.3,0,0,1-5.316-5.283,5.3,5.3,0,0,1,5.284-5.316A5.3,5.3,0,0,1-5.421,6.8v.019A5.3,5.3,0,0,1-10.7,12.12Z"
              fill="#069BD7"
            />
          </g>
        </svg>
      </div>
      <div class="topbar-item">
        <router-link
          :to="{ name: 'user-page', params: { userId: currentUser.id } }"
          >My Community Investment</router-link
        >
      </div>
      <div class="topbar-item relative">
        <a href="" @click.prevent="showNotificationsDrawer">Notifications</a>
        <span
          v-if="unreadNotificationsCounter"
          class="absolute bg-blue-light rounded-lg w-55 h-55 inline-block leading-tight text-white text-center text-lg -ml-2 -mt-1"
          >{{ unreadNotificationsCounter }}</span
        >
      </div>
      <div class="topbar-item">
        <a class="cursor-pointer" @click="showUserEdit">Update Info</a>
      </div>
    </div>
    <div class="flex flex-grow justify-between max-w-2xs">
      <div class="topbar-item">
        <router-link
          :to="{ name: 'user-page', params: { userId: currentUser.id } }"
        >
          <img
            :src="currentUser.image_url"
            class="rounded-full cursor-pointer post-avatar"
          />
        </router-link>
      </div>
      <div class="topbar-item">
        <a href=""></a>
        <router-link :to="{ name: 'logout' }"
          ><svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 882.35 1000"
            fill="#069bd7"
            height="17"
            width="15"
            class="inline-block -mt-1 mr-3"
          >
            <title>Kyndhub_Logout_Icon</title>
            <path
              d="M941.18,1000H323.53V941.18H882.35V58.82H323.53V0H941.18ZM411.76,806.29v-218H58.82V411.76H411.76v-218L718.06,500ZM117.65,529.41H470.59V664.29L634.88,500,470.59,335.71V470.59H117.65Z"
              transform="translate(-58.82)"
            /></svg
          >Logout</router-link
        >
      </div>
    </div>
  </div>
</template>
